import { createSelector } from "reselect";
import get from "lodash/get";
import { genericSelector } from "./appSettings";
import { simVerificationSelector } from "./forms/simVerification";
import { isIccIdValid } from "utils/helpers";

export const validateIccIdDomain = state => get(state, "api.validateIccId", {});

export const iccIdRegex = state =>
  get(state, "api.appSettings.data.global_config.validations", {});

export const iccIdRegexSelector = createSelector(iccIdRegex, iccid_reg =>
  get(iccid_reg, "iccid_regex")
);

export const enterICCIDDomain = state =>
  get(state, "api.enterICCICManually", {});

export const validateIccIdSelector = createSelector(
  validateIccIdDomain,
  validateIccId => get(validateIccId, "data", {})
);

export const enterICCIDDomainSelector = createSelector(
  enterICCIDDomain,
  ICCIDDomain => get(ICCIDDomain, "data.enterManually", true)
);

export const iccIdErrorSelector = iccIdInUrl =>
  createSelector(
    validateIccIdDomain,
    genericSelector,
    simVerificationSelector,
    iccIdRegexSelector,
    (validateIccId, generic, simVerificationForm, iccIdRegex) =>
      isIccIdValid(
        iccIdInUrl,
        generic,
        get(simVerificationForm, "icc_id", ""),
        iccIdRegex
      )
        ? get(validateIccId, "error", "")
        : iccIdInUrl
        ? "invalid_sim_card"
        : ""
  );

export const iccIdValidSelector = iccIdInUrl =>
  createSelector(
    genericSelector,
    simVerificationSelector,
    iccIdRegexSelector,
    (generic, simVerificationForm, iccIdRegex) =>
      isIccIdValid(
        iccIdInUrl,
        generic,
        get(simVerificationForm, "icc_id", ""),
        iccIdRegex
      )
  );

export const validateIccIdLoadingSelector = state =>
  get(state, "api.validateIccId.loading", false);

export const makeSelectValidateIccId = () => validateIccIdSelector;

export const makeSelectIccIdError = iccIdErrorSelector;

export const makeSelectIccIdValid = iccIdValidSelector;

export const makeSelectEnterICCIDDomain = () => enterICCIDDomainSelector;

export const makeSelectIccIdDetails = () => validateIccIdSelector;

export const makeSelectValidateIccidStatus = () => validateIccIdLoadingSelector;

export const makeSelectIccIdRegexSelector = () => iccIdRegexSelector;
